import { render } from "./PromoBlock.vue?vue&type=template&id=30fa962c&scoped=true"
import script from "./PromoBlock.vue?vue&type=script&lang=js"
export * from "./PromoBlock.vue?vue&type=script&lang=js"

import "./PromoBlock.vue?vue&type=style&index=0&id=30fa962c&scoped=true&lang=css"

import exportComponent from "D:\\DEV\\Actual\\SanElita\\elita_web_site\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-30fa962c"]])

export default __exports__